import styled from 'styled-components';
import media from '../base/media';
import { withFancyScrollbar } from '../base/utils';

export const Wrapper = styled.div`
	padding: 3rem;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	background-color: #fff;
	max-height: 80vh;
	max-width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	${withFancyScrollbar};

	${media.tablet`
		width: 54rem;
	`};
`;

export const Section = styled.div`
	padding: 3rem 1.5rem;
	margin-bottom: 1.5rem;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
`;

export const Text = styled.div`
	font-size: 1.6rem;
	line-height: 1.6;
	margin-bottom: 3rem;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	button {
		width: 100%;
	}

	${media.tablet`
		flex-direction: row;
	`};
`;
